<div class="fullscreen-icon" data-node-id="I209:669;36:4877;36:4867" (click)="onClick()">
  <sn-icon>fullscreen</sn-icon>
</div>
